export default "__VITE_ASSET__YFzZqYGo__"